import * as Sentry from '@sentry/browser';
import { LOGGED_USER_REQUEST_SUCCEEDED } from '@domain/logged-user/logged-user.state';
import { createHmac } from 'crypto';
import { AuthService } from '@domain/auth';
import { createMiddleware } from '../../../../shared/redux';
import { analytics } from '../analytics';

export const identifyMiddleware = createMiddleware({
    [LOGGED_USER_REQUEST_SUCCEEDED]: async (_, action) => {
        const newUserEmail = localStorage.getItem('NEW_USER_EMAIL');
        const { data } = action.payload;
        const emailHash = createHmac('sha256', data.email).digest('hex');

        if (data) {
            await analytics.identify(String(data.id), {
                userId: data.id,
                name: data.full_name,
                email: data.email,
                companyName: data.company.name,
            });
            if (emailHash === newUserEmail) {
                analytics.track('new_user');
            }
            // Sentry identify
            try {
                const userCognito = await AuthService.currentAuthenticatedUser();
                Sentry.setUser({
                    id: userCognito.attributes.sub,
                });
            } catch (e) {
                console.error({ sentrySetUserError: e });
            }
        }
    },
}, { beforeChanges: true });
